var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{},[_c('div',{},[_vm._m(0),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-10 md:px-16 py-2 bg-dmaGreen"},[_c('div',{staticClass:"font-black uppercase text-neutral-900"},[_c('h1',[_vm._v("Search")])])])
}]

export { render, staticRenderFns }